import React, { useCallback, useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import MainLayout from '../../layouts/MainLayout';
import BookWorldListComponent from '../learning/BookWorldListComponent';
import '../learning/styles/BookShelf.css'; 
// import BWButtons from './BookWorldButton';
import adImage from '../../assets/pageimages/bookworldlistad.webp';

const MindSparkBookWorld = () => {
    const navigate = useNavigate();
    const [param1, setParam1] = useState('f');
    const [param2, setParam2] = useState('mindspark');
    const [hoveredButton, setHoveredButton] = useState(null);
    const [activeButton, setActiveButton] = useState(null);

    const handleHover = (buttonId) => {
        setHoveredButton(buttonId);
    };

    const handleBlur = () => {
        setHoveredButton(null);
    };

    const setSearch = (p1, p2) => {
        setParam1(p1);
        setParam2(p2);
    };

    useEffect(() => {
        // Any additional logic if needed
    }, [param1, param2]);

    const handleClick = (action, id) => {
        if (action.startsWith('setSearch')) {
            const params = action.match(/\(([^)]+)\)/)[1].split(',').map(param => param.trim().replace(/['"]/g, ''));
            const [p1, p2] = params;
            setSearch(p1, p2);
        } else if (action.startsWith('navigate')) {
            const path = action.match(/\(([^)]+)\)/)[1].replace(/['"]/g, '');
            navigate(path);
        }
        setActiveButton(id);
    };

    return (
        <MainLayout>
            <div className="min-h-screen py-8 bg-gradient-to-r from-blue-300 via-green-500 to-purple-500 mt-12">
                <h2 className='text-xl font-bold text-white text-center'>MindSpark</h2>
                <div className="flex flex-col justify-center">
                    <h1 className='bg-orange-300 text-m mt-1 text-black flex justify-center align-middle'>
                        An Innovative Digital Platform for Learners, Authors, Publishers, Educational Trusts, NGOs, Corporate Learners, Digital Schools / Universities
                    </h1>
                </div>
                <div className="flex justify-center mt-2 mb-2">
                    <img className="align-middle" src={adImage} alt="Ad" />
                </div>
                <div>
                    <p className='text-m mt-1 mb-2 text-white flex justify-center align-middle'>
                        Select The Desired Button To Explore Available Books On Think5Whys Store 
                    </p>
                </div>
                <BookWorldListComponent param1={param1} param2={param2} />
                {/* <div className="bw-button-container">
                    {BWButtons.map((button) => (
                        <div key={button.id}>
                            <button
                                id={button.id}
                                className={`button-style ${button.className || ''}`}
                                style={{
                                    backgroundColor: hoveredButton === button.id ? button.hoverBackgroundColor : button.backgroundColor,
                                    color: hoveredButton === button.id ? button.hoverColor : button.color
                                }}
                                onClick={() => handleClick(button.onClick, button.id)}
                                onMouseEnter={() => handleHover(button.id)}
                                onMouseLeave={handleBlur}
                                onFocus={() => handleHover(button.id)}
                                onBlur={handleBlur}
                            >
                                {button.text}
                            </button>
                            {activeButton === button.id && (
                                <div className="full-width-container">
                                    <BookWorldListComponent param1={param1} param2={param2} />
                                </div>
                            )}
                        </div>
                    ))}
                </div> */}
            </div>
        </MainLayout>
    );
};

export default MindSparkBookWorld;
